import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useMutation } from '@tanstack/react-query'
import { organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostMutation } from '@/generated/@tanstack/react-query.gen'
import { DialogClose } from '@radix-ui/react-dialog'
import { toast } from '@/components/custom-toast'
import { useState } from 'react'
import { useUser } from '@/pages/enterprise/user-provider'

interface IProps {
  organizationId: number
  userId: string
  email: string
}

export default function ResetPasswordModal(props: IProps) {
  const [open, setOpen] = useState(false)
  const { onUpdateSeats } = useUser()
  const mutate = useMutation({
    ...organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostMutation(
      {}
    ),
    onError: (error) => {
      toast.error({
        message:
          (error.response?.data.detail as unknown as string) ?? error.message,
      })
    },
    onSuccess: () => {
      onUpdateSeats()
      toast.success({ message: 'Password reset successfully.' })
      setOpen(false)
    },
  })

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant={'window'} size={'sm'}>
          Reset Password
        </Button>
      </DialogTrigger>
      <DialogContent className="">
        <DialogHeader>
          <DialogTitle>Reset Password</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Are you sure you want to reset password of this user?
        </DialogDescription>
        <DialogFooter className="flex !justify-start">
          <Button
            disabled={mutate.isPending}
            onClick={() => {
              mutate.mutate({
                path: {
                  organization_id: props.organizationId,
                  useruuid: props.userId,
                },
              })
            }}
            className=""
          >
            Reset
          </Button>
          <DialogClose asChild>
            <Button
              variant="ghost"
              className=" text-primary hover:text-emerald-500 hover:bg-transparent"
            >
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
